import React, { useContext, useEffect, useMemo, useState } from "react";
import { TextField, Button, Box, Typography, Grid, Switch, FormControlLabel, Badge, Drawer } from "@mui/material";
import { SnackSimple } from "../../../../../../../../components";
import { useStyles } from "./styles";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { icons } from "../../../../../../../../utils/icons";
import MultiSelectSimple from "../../../../../../../../components/dinamicForm/multiSelectSimple";
import { useGetData } from "../../hooks/useGetData";
import { Item, ObjectGeneric, onChangeEvent } from "../../../../../../../../utils/types/generals";
import { DropListSubCategorie, FormContext } from "../../Context";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLocalStorage, LocaleNameType } from "../../../../../../../../utils/crud/crypt";
import { RequestErrors, Roles, Types } from "../../../../../../../../utils/enums";
import { Category, evidence, EvidenceState, FormattedCategory, Subcategory } from "../../Interfaces";
import { UploadEvidence } from "../../../../../../../../components/uploadEvidence";
import dayjs, { Dayjs } from "dayjs";
import { handleEvery } from "../../../../../../../calendar/pages/form/components/steps/assignDate/methods";
import { useFrequency } from "../../../../../../../../hooks/useFrequency/useFrequency";
import { Frequency } from "../../../../../../../../utils/enums/frequency";
import { Constants } from "../../../../../../../../utils/constants";
import { ConfirmModal } from "../../../FormCorrective/Components";
import { EvidenceGeneralConfig } from "../../../../../../../../components/uploadEvidence/types";
import { EvidencesFormat } from "../../../FormCorrective/Interfaces";
import { LoadingButton } from "@mui/lab";
import { handleAllErrors } from "../../../../../../../../utils/methods/handleErrors";
import { DateModalSimple } from "../../../../../../../../components/dinamicForm/dateModal";
import { toUnitTimeZone } from "../../../../../../../../utils/methods/calcDate";
import { Priority } from "../../../../../../../../utils/enums/priority";
import { EvidencesTypeValueEnum } from "../../../../../../../../utils/enums/evidences";


export const Step2 = ({ onBack }: { onBack: () => void }) => {

  const navigate = useNavigate();
  const { t } = useTranslation()
  const { unitys, questionnaires, getProvidersForUnit, providers, config, createFolio, editFolio, fetQuestionnaires } = useGetData();
  const state: { isManagerOfDeparment: boolean, role: number } = getLocalStorage(LocaleNameType.STATE)
  const isManagerOfDepartment = state?.isManagerOfDeparment
  const isAdmin = state?.role === Roles.ADMIN
  const { formData, updateFormData, id } = useContext(FormContext);
  const [snackMessage, setSnackMessage] = useState("");
  const [snackType, setSnackType] = useState<Types>(Types.SUCCESS);
  const [selectedUnit, setSelectedUnit] = useState<ObjectGeneric | null>(formData.selectedUnit || null);
  const [selectedtime, setSelectedtime] = useState<ObjectGeneric | null>(formData.selectedTime || null);
  const [startDate, setStartDate] = useState<Dayjs | null>(formData.startDate || null);
  const [endDate, setEndDate] = useState<Dayjs | null>(formData.endDate || null);
  const [executionDate, setExecutionDate] = useState<Dayjs | null>(formData.executionDate || null);
  const [selectedPriority, setSelectedPriority] = useState<ObjectGeneric | null>(formData.selectedPriority || null);
  const [selectedFrecuency, setSelectedFrecuency] = useState(formData.selectedFrecuency || null);
  const [selectedQuestionnarie, setSelectedQuestionnarie] = useState(formData.selestedQuestionnarie || null);
  const [selectedEvery, setSelectedEvery] = useState(formData.selectedEvery || null);
  const [selectedProvider, setSelectedProvider] = useState<ObjectGeneric | null>(formData.selectedProvider || null);
  const [title, setTitle] = useState(formData.title || "");
  const [description, setDescription] = useState(formData.description || "");
  const [manager, setManager] = useState<string>("");
  const [openUploadEvidence, setOpenUploadEvidence] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [evidencesDrawer, setEvidencesDrawer] = useState<EvidencesFormat>(formData.evidences ?? {
    open: false,
    type: {
      equivalence: [],
      accept: '',
    },
  })
  const [titleError, setTitleError] = useState<string | null>(null);
  const [descriptionError, setDescriptionError] = useState<string | null>(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [evidencesRequiredAreLoad, setEvidencesRequiredAreLoad] = useState<Record<string, boolean>>({});
  const [requiredEvidencesValid, setRequiredEvidencesValid] = useState(false);
  const [notifyAssignment, setNotifyAssignment] = useState(formData.notifyAssignment ?? false);
  const [error, setError] = useState({
    startDate: '',
    endDate: '',
    executionDate: ''
  });
  const [defaultValues, setDefaultValues] = useState<{ from?: Dayjs; to?: Dayjs; }>({ from: formData.startDate ?? dayjs().add(1, 'minute'), to: formData.endDate ?? null });
  const [defaultValuesQuestionaire, setDefaultValuesQuestionarie] = useState<{ from?: Dayjs; to?: Dayjs; }>({ from: formData.executionDate ?? dayjs().add(1, 'minute'), to: formData.executionEndDate ?? null });
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [isToBiggerThanFrom, setIsToBiggerThanFrom] = useState(dayjs(defaultValues.to).date() > dayjs(defaultValues.from).date())
  const [isToBiggerThanFromQuestionarie, setIsToBiggerThanFromQuestionaire] = useState(dayjs(defaultValuesQuestionaire.to).date() > dayjs(defaultValuesQuestionaire.from).date())
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [errorsQuestionarie, setErrorsQuestionarie] = useState<Record<string, string>>({})
  const [availablePriorities, setAvailablePriorities] = useState<any[]>([]);
  const [allProviders, setAllProviders] = useState<Item[]>([])
  const styles = useStyles();
  const frequency = useFrequency(defaultValues.from ? defaultValues.from.valueOf() : null, defaultValues.to ? defaultValues.to.valueOf() : null)
  const every = handleEvery(selectedFrecuency?.value)
  const priorityOptions = [
    { id: '4', value: Priority.URGENT, label: t('catalog.priority.4') },
    { id: '1', value: Priority.HIGH, label: t('catalog.priority.1') },
    { id: '2', value: Priority.MEDIUM, label: t('catalog.priority.2') },
    { id: '3', value: Priority.LOW, label: t('catalog.priority.3') }
  ];

  const timeOptions = [
    { value: "15", label: "15 minutos antes" },
    { value: "30", label: "30 minutos antes" },
    { value: "60", label: "60 minutos antes" }
  ];

  const handleUnitChange = async (e: onChangeEvent) => {
    const unitId = e.target.value;
    //setSelectedProvider(null)
    setSelectedQuestionnarie(null)
    if (!unitId) {
      setSelectedUnit(null);
      setManager("");
      setDefaultValues({ from: dayjs().add(1, 'minute'), to: null })
      setDefaultValuesQuestionarie({ from: dayjs().add(1, 'minute'), to: null })
      updateFormData({
        ...formData,
        selectedUnit: null,
        selestedQuestionnarie: null,
        selectedProvider: null,
        startDate: dayjs().add(1, 'minute'),
        endDate: null,
        executionDate: dayjs().add(1, 'minute'),
        executionEndDate: null
      });
      return;
    }

    setSelectedUnit(unitId);

    if (formData.department?.value) {
      await getProvidersForUnit(unitId.value, formData.department.value, formData.selectedProviderCopy as Item);
      //updateProvidersList(providers);
    }

    const unityTimeZoneCode = toUnitTimeZone(new Date(), unitId?.extraData?.timeZone?.value);

    setDefaultValues({ from: dayjs(unityTimeZoneCode).add(1, 'minute'), to: null })
    setDefaultValuesQuestionarie({ from: dayjs(unityTimeZoneCode).add(1, 'minute'), to: null })

    updateFormData({
      ...formData,
      selectedUnit: unitId,
      selestedQuestionnarie: null,
      //selectedProvider: null,
      startDate: dayjs(unityTimeZoneCode).add(1, 'minute'),
      endDate: null,
      executionDate: dayjs(unityTimeZoneCode).add(1, 'minute'),
      executionEndDate: null
    });

  };

  const getDate = (date: Dayjs, name: 'to' | 'from') => {
    setDefaultValues(prev => ({ ...prev, [name]: date }))
    if (name == 'from') {
      updateFormData({
        ...formData,
        startDate: date
      });
    } else {
      updateFormData({
        ...formData,
        endDate: date
      });
    }
  }

  // Función para obtener todas las prioridades únicas de las categorías seleccionadas
  const getUniquePriorities = () => {
    if (isManagerOfDepartment || isAdmin) {
      return priorityOptions;
    }

    const priorities = new Set();
    const priorityMap = new Map();

    if (formData.selectedSubcategories) {
      formData.selectedSubcategories.forEach((selectedSub: any) => {
        formData.categories.forEach((category: any) => {
          const subcategory = category.subcategories.find(
            (sub: any) => sub.id === selectedSub.id
          );
          if (subcategory?.priority) {
            priorities.add(subcategory.priority.id);
            priorityMap.set(subcategory.priority.id, {
              label: subcategory.priority.name,
              value: subcategory.priority.id.toString()
            });
          }
        });
      });
      return Array.from(priorities).map(id => priorityMap.get(id));
    }
    return [];
  };

  const PRIORITY_WEIGHT: Record<number, number> = {
    4: 1,
    1: 2,
    2: 3,
    3: 4,
  };

  // Función para obtener la prioridad más alta
  const getHighestPriority = () => {
    let highestPriority = null;
    let lowestPriorityId = Infinity; // Menor ID = mayor prioridad

    if (formData.selectedSubcategories) {
      formData.selectedSubcategories.forEach((selectedSub: any) => {
        formData.categories.forEach((category: any) => {
          const subcategory = category.subcategories.find(
            (sub: any) => sub.id === selectedSub.id
          );
          if (subcategory?.priority && PRIORITY_WEIGHT[subcategory.priority.id] < lowestPriorityId) {
            lowestPriorityId = PRIORITY_WEIGHT[subcategory.priority.id];
            highestPriority = subcategory.priority.id.toString();
          }
        });
      });

      return highestPriority;
    } else {
      return null
    }

  };

  const getHighestProvider = () => {
    let highestPriority = null;
    let lowestPriorityId = Infinity; // Menor ID = mayor prioridad
    let provider = null;

    if (formData.selectedSubcategories) {
      formData.selectedSubcategories.forEach((selectedSub: any) => {
        formData.categories.forEach((category: any) => {
          const subcategory = category.subcategories.find(
            (sub: any) => sub.id === selectedSub.id
          );
          if (subcategory?.user && PRIORITY_WEIGHT[subcategory.priority.id] < lowestPriorityId) {
            lowestPriorityId = PRIORITY_WEIGHT[subcategory.priority.id];
            highestPriority = subcategory.priority.id.toString();
            provider = { label: `${subcategory.user.firstName} ${subcategory.user.lastName}`, value: subcategory.user.id }
          }
        });
      });

      return provider;
    } else {
      return null
    }

  };

  const subCategoriesProviders = () => {
    if (formData.selectedSubcategories) {
      return formData.selectedSubcategories
        .filter(sub => sub.user) // Filtra solo los que tienen 'user'
        .map(sub => sub.user);
    } else {
      return []
    }
  }

  useEffect(() => {
    const priorities = getUniquePriorities();
    const provider = getHighestProvider();
    setAvailablePriorities(priorities);

    if(id) return;

    // Reset priority when subcategories change
    if (formData.selectedSubcategories) {
      const highestPriority = getHighestPriority();
      if (highestPriority /* && !id */) {
        setSelectedPriority(highestPriority);
        if (provider) {
          setSelectedProvider(provider)
        }
        updateFormData({
          ...formData,
          selectedPriority: highestPriority,
          selectedProvider: /* !selectedProvider ? */ provider ? provider : formData.selectedProvider
        });
      }

    }
  }, [formData.selectedSubcategories]);


  useEffect(() => {
    const providersFromCategories = subCategoriesProviders();
    const mergedArray = [
      ...providers,
      ...providersFromCategories.filter(item2 => !providers.some(item1 => item1.value === item2.value))
    ];
    setAllProviders(mergedArray)

  }, [selectedPriority, selectedUnit, formData.selectedSubcategories, providers]);

  useEffect(() => {
    let errorMessageFrom = ''
    let errorMessageTo = ''
    let errorMessageQuestionarieFrom = ''
    let errorMessageQuestionarieTo = ''

    if (dayjs(defaultValues.to).isBefore(dayjs(defaultValues.from).add(5, 'minute'))) { errorMessageTo = t('general.validations.minimus5minute') }

    if (dayjs(defaultValuesQuestionaire.to).isBefore(dayjs(defaultValuesQuestionaire.from).add(5, 'minute'))) { errorMessageQuestionarieTo = t('general.validations.minimus5minute') }

    if (dayjs(defaultValuesQuestionaire.from).add(5, 'minute').isAfter(dayjs(defaultValues.to))) { errorMessageQuestionarieFrom = t('general.validations.afterEndDate') }

    if (dayjs(defaultValues.from).isAfter(dayjs(defaultValuesQuestionaire.from))) { errorMessageQuestionarieFrom = t('general.validations.beforeStartDate') }

    if (dayjs(defaultValuesQuestionaire.to).isAfter(dayjs(defaultValues.to))) { errorMessageQuestionarieTo = t('general.validations.beforeStartDateQuestionarie') }

    if (dayjs(defaultValues.from).isAfter(dayjs(defaultValuesQuestionaire.to))) { errorMessageQuestionarieTo = t('general.validations.afterEndDateQuestionarie') }

    setErrors(prev => ({
      ...prev,
      to: errorMessageTo,
      from: errorMessageFrom
    }))

    setErrorsQuestionarie(prev => ({
      ...prev,
      from: errorMessageQuestionarieFrom,
      to: errorMessageQuestionarieTo
    }))
  }, [defaultValues, defaultValuesQuestionaire])

  /*   useEffect(() => {
      const unityTimeZoneCode = toUnitTimeZone(new Date(), selectedUnit?.extraData?.timeZone?.value);
  
      if (selectedUnit?.extraData?.timeZone) {
        const isMinor = dayjs(defaultValues.from).isBefore(dayjs(unityTimeZoneCode))
        if (isMinor) {
          setDefaultValues({ from: dayjs(unityTimeZoneCode).add(1, 'minute'), to: null })
          updateFormData({
            ...formData,
            startDate: dayjs(unityTimeZoneCode).add(1, 'minute')
          });
        }
      } else {
        const isMinor = dayjs(defaultValues.from).isBefore(dayjs())
        if (isMinor) {
          setDefaultValues({ from: dayjs().add(1, 'minute'), to: null })
          updateFormData({
            ...formData,
            startDate: dayjs(unityTimeZoneCode).add(1, 'minute')
          });
        }
      }
  
    }, [selectedUnit]); */

  const getDateQuestionarie = (date: Dayjs, name: 'to' | 'from') => {
    setDefaultValuesQuestionarie(prev => ({ ...prev, [name]: date }))
    if (name == 'from') {
      updateFormData({
        ...formData,
        executionDate: date
      });
    } else {
      updateFormData({
        ...formData,
        executionEndDate: date
      });
    }
  }

  /*  useEffect(() => {
     let errorMessage = ''
 
     if (dayjs(defaultValuesQuestionaire.to).isBefore(dayjs(defaultValuesQuestionaire.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
 
     setErrorsQuestionarie(prev => ({
       ...prev,
       to: errorMessage
     }))
   }, [defaultValuesQuestionaire]) */

  useEffect(() => {
    if (selectedUnit?.value && formData.department?.value) {
      getProvidersForUnit(selectedUnit.value, formData.department.value, formData.selectedProviderCopy as Item);
    }
  }, []);

  useEffect(() => {
    if (formData.selectedProvider) {
      fetQuestionnaires(formData.selectedProvider.value);
    }
  }, [selectedProvider]);

  useEffect(() => {
    if (formData.startDate && formData.startDate.isBefore(dayjs(), "minute")) {
      setError(prev => ({
        ...prev,
        startDate: "La fecha debe ser mayor o igual a la actual"
      }));
    }
  }, []);

  useEffect(() => {
    if (selectedUnit) {
      const selectedUnityData = unitys.find(unit => unit.value === Number(selectedUnit.value));
      if (selectedUnityData?.extraData?.user) {
        const { firstName, lastName } = selectedUnityData.extraData.user;
        setManager(`${firstName} ${lastName}`);
      } else {
        setManager("No hay un encargado asociado a esta unidad");
      }
    } else {
      setManager("");
    }
  }, [selectedUnit, unitys]);

  const handleTimeChange = (e: onChangeEvent) => {
    const timeId = e.target.value;
    setSelectedtime(timeId);
    updateFormData({
      ...formData,
      selectedTime: timeId
    });
  }

  const handlestartDate = (value: Dayjs | null) => {
    setStartDate(value)
    setSelectedFrecuency(null)
    setSelectedEvery(null)
    setExecutionDate(null)
    updateFormData({
      ...formData,
      startDate: value,
      selectedEvery: null,
      selectedFrecuency: null,
      executionDate: null
    });

    if (value && value.isBefore(dayjs(), "minute")) {
      setError(prev => ({
        ...prev,
        startDate: "La fecha debe ser mayor o igual a la actual"
      }));
    } else {
      setError(prev => ({
        ...prev,
        startDate: ""
      }));
    }

    if (value && endDate && endDate.isBefore(value.add(5, 'minute'), "minute")) {
      setError(prev => ({
        ...prev,
        endDate: "La fecha debe ser 5 minutos mayor a la fecha inicio"
      }));
    } else {
      setError(prev => ({
        ...prev,
        endDate: ""
      }));
    }
  }

  const handleEndDate = (value: Dayjs | null) => {
    setEndDate(value)
    setSelectedFrecuency(null)
    setExecutionDate(null)
    setSelectedEvery(null)
    updateFormData({
      ...formData,
      endDate: value,
      selectedEvery: null,
      selectedFrecuency: null,
      executionDate: null
    });
    if (value && value.isBefore(startDate?.add(5, 'minute'), "minute")) {
      setError(prev => ({
        ...prev,
        endDate: "La fecha debe ser 5 minutos mayor a la fecha inicio"
      }));
    } else {
      setError(prev => ({
        ...prev,
        endDate: ""
      }));
    }
  }

  const handleFrecuency = (e: onChangeEvent) => {
    const frecuencyId = e.target.value;
    setSelectedFrecuency(frecuencyId)
    setSelectedEvery(null)
    updateFormData({
      ...formData,
      selectedFrecuency: frecuencyId,
      selectedEvery: null
    });
  }

  const handleQuestionnarie = (e: onChangeEvent) => {
    const questionnarieId = e.target.value;
    setSelectedQuestionnarie(questionnarieId)
    updateFormData({
      ...formData,
      selestedQuestionnarie: questionnarieId,
    });
  }

  const handleEveryChange = (e: onChangeEvent) => {
    const everyId = e.target.value;
    setSelectedEvery(everyId)
    updateFormData({
      ...formData,
      selectedEvery: everyId
    });
  }

  const handleExecutionDate = (value: Dayjs | null) => {
    setExecutionDate(value)
    updateFormData({
      ...formData,
      executionDate: value
    });
    if (value && value.isBefore(startDate, "minute")) {
      setError(prev => ({
        ...prev,
        executionDate: "La fecha debe ser mayor o igual a la fecha inicio"
      }));
      return;
    }

    if (value && endDate && endDate.isBefore(value, "minute")) {
      setError(prev => ({
        ...prev,
        executionDate: "La fecha debe ser menor o igual a la fecha fin"
      }));
    } else {
      setError(prev => ({
        ...prev,
        executionDate: ""
      }));
    }
  }

  const handlePriorityChange = (e: onChangeEvent) => {
    const priorityId = e.target.value;

    if (priorityId) {
      setSelectedPriority(priorityId);
      updateFormData({
        ...formData,
        selectedPriority: priorityId
      });


      const provider = getHighestProvider();

      // Reset priority when subcategories change
      if (formData.selectedSubcategories && (priorityId.value == Priority.URGENT || priorityId.value == Priority.HIGH)) {
        if (!selectedProvider && provider) {
          setSelectedProvider(provider)
        }
        updateFormData({
          ...formData,
          selectedProvider: !selectedProvider && provider ? provider : formData.selectedProvider
        });
      } else {
        setSelectedProvider(null)
        updateFormData({
          ...formData,
          selectedProvider: null
        });
      }

    } else {
      setSelectedPriority(null);
      updateFormData({
        ...formData,
        selectedPriority: null
      });
    }
  };

  const handleProviderChange = (e: onChangeEvent) => {
    const providerId = e.target.value;
    if (providerId) {
      fetQuestionnaires(providerId.value)
      setSelectedQuestionnarie(null)
      setSelectedProvider(providerId);
      updateFormData({
        ...formData,
        selectedProvider: providerId,
        selestedQuestionnarie: null
      });
      return;
    } else {
      setSelectedQuestionnarie(null)
      setSelectedProvider(null)
      updateFormData({
        ...formData,
        selectedProvider: null,
        selestedQuestionnarie: null
      });
    }
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;
    setTitle(newTitle);

    if (newTitle.trim().length < 3) {
      setTitleError("Debe tener al menos 3 caracteres");
    } else {
      updateFormData({
        ...formData,
        title: newTitle
      });
      setTitleError(null);
    }
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDescription = e.target.value;
    setDescription(newDescription);

    if (newDescription.trim().length < 3) {
      setDescriptionError("Debe tener al menos 3 caracteres");
    } else {
      updateFormData({
        ...formData,
        description: newDescription
      });
      setDescriptionError(null);
    }
  };

  const handleAttachDocument = () => {
    setOpenUploadEvidence(true);
    setEvidencesDrawer(prev => ({
      ...prev,
      open: true
    }));
  };

  const handleCloseUpload = () => {
    setOpenUploadEvidence(false);
    setEvidencesDrawer(prev => ({
      ...prev,
      open: false
    }));
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    updateFormData({
      ...formData,
      evidences: evidencesDrawer
    });
  }, [evidencesDrawer]);

  const validateRequiredEvidences = useMemo(() => {
    if (!evidencesDrawer.value) return false;

    return Object.entries(evidencesDrawer.value).every(([_, typeData]) => {
      if (!typeData.required) return true;

      const filesCount = Object.keys(typeData.value || {}).length;
      return filesCount >= (typeData.minAmount || 1);
    });
  }, [evidencesDrawer.value]);

  useEffect(() => {
    setRequiredEvidencesValid(validateRequiredEvidences);
  }, [validateRequiredEvidences]);

  const createEvidenceTypes = config?.configActionPlanReportFolioEvidenceTypes?.filter(
    (item: EvidenceGeneralConfig) => item.type === 'CREATE'
  );

  const isRequired = !!(
    Array.isArray(createEvidenceTypes) &&
    createEvidenceTypes.some((item: EvidenceGeneralConfig) => item.required === true)
  );

  const hasEvidenceConfig = Array.isArray(createEvidenceTypes) && createEvidenceTypes.length > 0;

  /* const isRequired = !!(config?.configActionPlanReportFolioEvidenceTypes && Array.isArray(config.configActionPlanReportFolioEvidenceTypes) && config.configActionPlanReportFolioEvidenceTypes.some((item: EvidenceGeneralConfig) => item.required === true));
  const hasEvidenceConfig = config?.configActionPlanReportFolioEvidenceTypes?.length > 0; */
  const hasErrors = Object.values(errors).some(error => error.trim() !== '');
  const hasErrorsQuestionarie = Object.values(errorsQuestionarie).some(error => error.trim() !== '');

  const isFormValid = selectedUnit &&
    !hasErrors &&
    !hasErrorsQuestionarie &&
    /* selectedProvider && */
    selectedPriority &&
    questionnaires.length !== 0 &&
    defaultValues.from &&
    defaultValues.to &&
    (!id ? selectedFrecuency : true) &&
    ((selectedFrecuency?.value === Frequency.WEEKLY || selectedFrecuency?.value === Frequency.MONTH) ? selectedEvery : true) &&
    (selectedFrecuency?.value === Frequency.DAILY ? defaultValuesQuestionaire.from : true) &&
    selectedQuestionnarie &&
    (notifyAssignment ? selectedtime : true) &&
    title &&
    title.trim().length >= 3 &&
    description &&
    description.trim().length >= 3 &&
    (!hasEvidenceConfig || requiredEvidencesValid);

  const formatCategories = (
    categories: Category[],
    selectedSubcategories: Subcategory[],
    formData: any,
    categoriesCopy?: Category[],
  ): FormattedCategory[] => {
    const formattedCategories: FormattedCategory[] = [];

    const flattenDropList = (list: DropListSubCategorie[], result: DropListSubCategorie[] = []): DropListSubCategorie[] => {
      for (const item of list) {
        result.push(item);
        if (item.dropList && item.dropList.length > 0) {
          flattenDropList(item.dropList, result);
        }
      }
      return result;
    };

    categories.forEach(category => {
      category.subcategories.forEach(subcategory => {

        const matches = selectedSubcategories.filter(sel => sel.id === subcategory.id);

        matches.forEach(sel => {
          const allDropItems = flattenDropList(sel.dropList);

          const configAnswer = allDropItems.map((item, index) => ({
            currentNode: item.currentNode ?? 0,
            id: item.value,
            name: item.label,
          }));

          formattedCategories.push({
            categoryId: category.id,
            category: category.name,
            subcategoryId: subcategory.id,
            subcategory: subcategory.name,
            priorityId: subcategory.priority.id,
            priority: subcategory.priority.name,
            requestText: subcategory.requestText,
            listText: sel.textRequest ?? '',
            userAssignId: subcategory.user?.id || null,
            configAnswer,
            versionDropDownsLinksId: subcategory.version ?? undefined,
            idArray: sel.idArray
          });
        });
      });
    });

    const existingSubcategoryKeys = new Set(
      formattedCategories.map(fc => `${fc.subcategoryId}-${fc.idArray ?? 0}`)
    );

    if (!!id) {
      categoriesCopy?.forEach(category => {
        category.subcategories.forEach(subcategory => {
          const matches = selectedSubcategories.filter(sel => sel.id === subcategory.id);

          matches.forEach(sel => {
            const allDropItems = flattenDropList(sel.dropList);

            const configAnswer = allDropItems.map((item, index) => ({
              currentNode: item.currentNode ?? 0,
              id: item.value,
              name: item.label,
            }));

            const key = `${subcategory.id}-${sel.idArray ?? 0}`;

            if (!existingSubcategoryKeys.has(key)) {
              formattedCategories.push({
                categoryId: category.id,
                category: category.name,
                subcategoryId: subcategory.id,
                subcategory: subcategory.name,
                priorityId: subcategory.priority.id,
                priority: subcategory.priority.name,
                requestText: subcategory.requestText,
                listText: sel.textRequest ?? '',
                userAssignId: subcategory.user?.id || null,
                configAnswer,
                versionDropDownsLinksId: sel.version ?? subcategory.version ?? undefined,
              });

              existingSubcategoryKeys.add(key);
            }
          });
        });
      });
    }

    return formattedCategories.map(({ idArray, ...rest }) => rest);
  };

  const handleSubmit = async () => {
    const evidences: evidence[] = [];
    const comments: string[] = [];

    const formattedCategories = formatCategories(
      formData.categories,
      formData.selectedSubcategories ?? [],
      formData,
      formData.categoriesCopy,
    );

    if (evidencesDrawer.value) {
      Object.entries(evidencesDrawer.value).forEach(([typeId, typeData]) => {
        if (typeData.value) {
          Object.values(typeData.value).forEach(file => {
            if (file.url && Number(typeId) !== EvidencesTypeValueEnum.COMMENT && Number(typeId) !== EvidencesTypeValueEnum.OBSERVATION_COMMENT) {
              evidences.push({
                url: file.url,
                originalname: file.name,
                evidenceTypeId: typeId,
              });
            }
            if ((Number(typeId) === EvidencesTypeValueEnum.OBSERVATION_COMMENT || Number(typeId) === EvidencesTypeValueEnum.COMMENT) && file.url) {
              comments.push(String(file.url));
            }
          });
        }
      });
    }

    const submitData = !id ? {
      reportFolios: [
        {
          areaId: Number(formData.area?.id),
          departmentId: Number(formData.department?.value),
          storeId: Number(selectedUnit?.value),
          priorityId: Number(selectedPriority?.value || selectedPriority),
          userAssignId: selectedProvider?.value,
          name: title,
          description,
          evidences,
          comments,
          categories: formattedCategories,
          type: "preventive",
          dateStart: defaultValues.from?.format(Constants.dayjsFormat3),
          dateEnd: defaultValues.to?.format(Constants.dayjsFormat3),
          dateQuestionnaire: defaultValuesQuestionaire.from?.format(Constants.dayjsFormat3),
          dateEndQuestionnaire: defaultValuesQuestionaire.to?.format(Constants.dayjsFormat3),
          frequency: selectedFrecuency?.value,
          every: selectedEvery?.value,
          questionnaireId: Number(selectedQuestionnarie?.value),
          notified: notifyAssignment ? 1 : 0,
          timeNotification: Number(selectedtime?.value)
        },
      ],
    }
      :
      {
        areaId: Number(formData.area?.id),
        departmentId: Number(formData.department?.value),
        storeId: Number(selectedUnit?.value),
        priorityId: Number(selectedPriority?.value || selectedPriority),
        userAssignId: selectedProvider?.value,
        name: title,
        description,
        evidences,
        comments,
        categories: formattedCategories,
        type: "preventive",
        dateStart: defaultValues.from?.format(Constants.dayjsFormat3),
        dateEnd: defaultValues.to?.format(Constants.dayjsFormat3),
        dateQuestionnaire: defaultValuesQuestionaire.from?.format(Constants.dayjsFormat3),
        dateEndQuestionnaire: defaultValuesQuestionaire.to?.format(Constants.dayjsFormat3),
        frequency: selectedFrecuency?.value,
        every: selectedEvery?.value,
        questionnaireId: Number(selectedQuestionnarie?.value),
        notified: notifyAssignment ? 1 : 0,
        timeNotification: Number(selectedtime?.value)
      };


    setIsSubmitting(true);
    try {
      if (!id) {
        const response: any = await createFolio(submitData);
        //@ts-ignore
        if (response.errors || response.code === RequestErrors.ERR_DUPLICATE_FOLIO || response.code === RequestErrors.VALIDATION_ERROR || response.code == RequestErrors.ERR_NOT_HAVE_CONFIGURATION || response.code == RequestErrors.ERR_VISIT_NOT_CREATED || response.code == RequestErrors.ERR_SCHEDULE_VISIT) {
          //@ts-ignore

          const isLimit = response.code == RequestErrors.ERR_NOT_HAVE_CONFIGURATION ? response.data[0].error ? true : false : false;
          const duplicatedFolios: string = isLimit ? handleAllErrors(RequestErrors.ERR_LIMIT_EXCEEDED, t) : handleAllErrors(response?.code, t);
          setSnackbarOpen(true);
          setSnackMessage(duplicatedFolios);
          setSnackType(Types.ERROR);
        } else {
          setSnackMessage("Folio creado exitosamente");
          setSnackType(Types.SUCCESS);
          setSnackbarOpen(true);
          setTimeout(() => {
            navigate("/dashboard/report-folio/dashboard");
          }, 2000);
        }
      } else {
        const response = await editFolio(submitData, Number(id));
        //@ts-ignore

        if (response.code === RequestErrors.VALIDATION_ERROR || response.code === RequestErrors.ERR_NOT_FOUND || response.code === RequestErrors.ERR_NOT_ALLOWED || response.code === RequestErrors.ERR_UNAUTHORIZED) {
          //@ts-ignore
          const duplicatedFolios: string = handleAllErrors(response?.code, t);
          setSnackbarOpen(true);
          setSnackMessage(duplicatedFolios);
          setSnackType(Types.ERROR);
        } else {
          setSnackMessage("Folio editado exitosamente");
          setSnackType(Types.SUCCESS);
          setSnackbarOpen(true);
          setTimeout(() => {
            navigate("/dashboard/report-folio/dashboard");
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
      setSnackMessage("Error al crear el folio");
      setSnackType(Types.ERROR);
      setSnackbarOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const shouldShowBadge = useMemo(() => {
    if (!evidencesDrawer.value || !isRequired) return false;

    return Object.entries(evidencesDrawer.value).some(([_, typeData]) => {
      if (!typeData.required) return false;
      const filesCount = Object.keys(typeData.value || {}).length;
      return filesCount < (typeData.minAmount || 1);
    });
  }, [evidencesDrawer.value, isRequired]);



  const handleToggleSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNotifyAssignment(event.target.checked);
    setSelectedtime({ value: "60", label: "60 minutos antes" })
    updateFormData({
      ...formData,
      selectedTime: { value: "60", label: "60 minutos antes" },
      notifyAssignment: event.target.checked
    });
  };


  return (
    <Box>
      <Grid container spacing={4} >
        {/* Sección de asignación de unidad */}
        <Grid item xl={5} sm={12}>
          <Grid container spacing={2}>
            {/* Primera fila */}
            <Grid item xs={6}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Asignar unidad
                </Typography>
                <MultiSelectSimple
                  errors={null}
                  name="Unidad"
                  label={"Unidad *"}
                  onChange={handleUnitChange}
                  items={unitys}
                  selected={selectedUnit}
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Encargado
                </Typography>
                <Typography
                  sx={{
                    color: manager.includes("No hay") ? "text.secondary" : "text.primary",
                    fontStyle: manager.includes("No hay") ? "italic" : "normal"
                  }}
                >
                  {manager}
                </Typography>
              </Box>
            </Grid>

            {/* Segunda fila */}
            <Grid item xs={6}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Asignar prioridad
                </Typography>
                <MultiSelectSimple
                  isRequired
                  errors={null}
                  name="Prioridad"
                  label={"Prioridad *"}
                  onChange={handlePriorityChange}
                  items={availablePriorities/* priorityOptions */}
                  selected={selectedPriority}
                  disabled={!isManagerOfDepartment && !isAdmin}
                />
              </Box>
            </Grid>

            {(isManagerOfDepartment || isAdmin) ? (
              <Grid item xs={6}>
                <Box>
                  <Typography variant="subtitle2" gutterBottom>
                    Asignar proveedor
                  </Typography>
                  <MultiSelectSimple
                    isRequired
                    errors={null}
                    name="Proveedor"
                    label={"Proveedor"}
                    onChange={handleProviderChange}
                    items={allProviders}
                    selected={selectedProvider}
                    disabled={(!selectedUnit || !formData.department) || (!isManagerOfDepartment && !isAdmin)}
                  />
                </Box>
              </Grid>
            ) : <>
            </>
            }

            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Programar mantenimiento
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <DateModalSimple
                  timeZone={selectedUnit?.extraData?.timeZone?.code ?? localTimeZone}
                  setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                  buttonTitle="Fecha inicio *"
                  defaultDate={defaultValues.from}
                  errorMsg={errors?.from}
                  error={!!(errors.from)}
                  getDate={(date) => { getDate(date, 'from') }}
                  payload={{ max: defaultValues.to, min: selectedUnit?.extraData?.timeZone ? dayjs(toUnitTimeZone(new Date(), selectedUnit?.extraData?.timeZone?.value)) : dayjs(), is: { start: true, startLower: isToBiggerThanFrom } }}
                  title='SELECCIÓN DE FECHA DE INICIO' name="from"
                />

              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <DateModalSimple
                  timeZone={selectedUnit?.extraData?.timeZone?.code ?? localTimeZone}
                  setIsToBiggerThanFrom={setIsToBiggerThanFrom}
                  buttonTitle="Fecha fin *"
                  defaultDate={defaultValues.to}
                  errorMsg={errors?.to}
                  error={!!(errors.to)}
                  getDate={(date) => { getDate(date, 'to') }}
                  payload={{ min: dayjs(defaultValues.from) ?? dayjs(), is: { end: true, endBigger: isToBiggerThanFrom } }}
                  title='SELECCIÓN DE FECHA DE FIN' name="to"
                />


              </Box>
            </Grid>

            {!id &&
              <Grid item xs={6}>
                <Box>
                  <MultiSelectSimple
                    isRequired
                    errors={null}
                    name="Ejecution"
                    label={"Ejecución única *"}
                    onChange={handleFrecuency}
                    items={frequency}
                    selected={selectedFrecuency}
                    disabled={!defaultValues.from || !defaultValues.to}
                  />
                </Box>
              </Grid>
            }

            {!id &&
              <Grid item xs={6}>
                {!!every && (
                  <Box>
                    <MultiSelectSimple
                      items={every}
                      name="every"
                      label={`${t('general.selected')} *`}
                      selected={selectedEvery}
                      onChange={handleEveryChange}
                      errors={null}
                      isRequired
                    />
                  </Box>
                )}
              </Grid>
            }

            <Grid item xs={12}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Cuestionario
                </Typography>
              </Box>
            </Grid>


            <Grid item xs={6}>
              <Box>
                <DateModalSimple
                  timeZone={selectedUnit?.extraData?.timeZone?.code ?? localTimeZone}
                  setIsToBiggerThanFrom={setIsToBiggerThanFromQuestionaire}
                  buttonTitle="Fecha inicio de ejecución*"
                  defaultDate={defaultValuesQuestionaire.from}
                  errorMsg={errorsQuestionarie?.from}
                  error={!!(errorsQuestionarie.from)}
                  getDate={(date) => { getDateQuestionarie(date, 'from') }}
                  payload={{ max: defaultValuesQuestionaire.to ? defaultValuesQuestionaire.to : dayjs(defaultValues.to).subtract(5, 'minute'), min: dayjs(defaultValues.from) ?? dayjs(), is: { start: true, endBigger: isToBiggerThanFromQuestionarie } }}
                  title='SELECCIÓN DE FECHA DE INICIO' name="from"
                />
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <DateModalSimple
                  timeZone={selectedUnit?.extraData?.timeZone?.code ?? localTimeZone}
                  setIsToBiggerThanFrom={setIsToBiggerThanFromQuestionaire}
                  buttonTitle="Fecha fin de ejecución*"
                  defaultDate={defaultValuesQuestionaire.to}
                  errorMsg={errorsQuestionarie?.to}
                  error={!!(errorsQuestionarie.to)}
                  getDate={(date) => { getDateQuestionarie(date, 'to') }}
                  payload={{ max: (defaultValues.to), min: dayjs(defaultValuesQuestionaire.from) ?? dayjs(), is: { end: true, endBigger: isToBiggerThanFromQuestionarie } }}
                  title='SELECCIÓN DE FECHA DE FIN' name="to"
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box>

                <MultiSelectSimple
                  isRequired
                  errors={null}
                  name="Cuestionarie"
                  label={"Cuestionario *"}
                  onChange={handleQuestionnarie}
                  items={questionnaires}
                  selected={selectedQuestionnarie}
                  disabled={!selectedProvider}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Notificar asignación
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={notifyAssignment}
                      onChange={handleToggleSwitch}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "green", // Cambia el color del thumb (círculo)
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: "green", // Cambia el color del track
                        },
                      }}
                    />
                  }
                  label="Activar notificaciones"
                  sx={{ marginLeft: 0 }}
                />

              </Box>
            </Grid>

            {notifyAssignment && (
              <Grid item xs={6}>
                <Box>
                  <MultiSelectSimple
                    isRequired
                    errors={null}
                    name="MargenTiempo"
                    label={"Margen de tiempo *"}
                    onChange={handleTimeChange}
                    items={timeOptions}
                    selected={selectedtime}
                  />
                </Box>
              </Grid>
            )}

          </Grid>
        </Grid>

        {/* Sección de solicitud */}
        <Grid item xl={7} sm={12}>
          <Grid container spacing={2}>

            <Grid item xl={10} sm={10}>
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Solicitud
                </Typography>
                <TextField
                  fullWidth
                  required
                  label="Título"
                  placeholder="Escriba el título de la solicitud"
                  value={title}
                  onChange={handleTitleChange}
                  error={!!titleError}
                  helperText={titleError}
                  inputProps={{ maxLength: 45 }}
                />
              </Box>

            </Grid>

            <Grid item xl={2} sm={2}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
                height="100%"
                sx={{
                  marginTop: 1,
                }}
              >

                {shouldShowBadge ? (
                  <Badge sx={styles.badge(isRequired)} badgeContent={icons('priorityHigh')}>
                    <Button
                      variant="contained"
                      onClick={handleAttachDocument}
                      sx={styles.button}
                      disabled={!hasEvidenceConfig}
                    >
                      <AttachFileIcon />
                    </Button>
                  </Badge>
                ) : (
                  <Button
                    variant="contained"
                    onClick={handleAttachDocument}
                    sx={styles.button}
                    disabled={!hasEvidenceConfig}
                  >
                    <AttachFileIcon />
                  </Button>
                )}
              </Box>
            </Grid>

            <Grid item xl={12} sm={12}>
              <Box>
                <TextField
                  fullWidth
                  required
                  label="Descripción"
                  placeholder="Descripción de la solicitud..."
                  multiline
                  rows={4}
                  value={description}
                  onChange={handleDescriptionChange}
                  error={!!descriptionError}
                  helperText={descriptionError}
                />
              </Box>
            </Grid>

          </Grid>

        </Grid>
      </Grid>

      <SnackSimple
        open={snackbarOpen}
        close={handleCloseSnackbar}
        message={snackMessage}
        type={snackType}
      />

      <Drawer
        anchor="right"
        open={evidencesDrawer.open}
        onClose={handleCloseUpload}
        PaperProps={{
          sx: {
            width: "30%", // Ajusta el ancho del Drawer a tu necesidad
          },
        }}
      >
        <Box p={2} sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" gutterBottom>
            Evidencias
          </Typography>

          {/* Aquí incluirías el componente UploadEvidence */}
          {openUploadEvidence && (
            <UploadEvidence
              uploadName="Report-folio-corrective"
              evidencesDrawer={evidencesDrawer as EvidenceState} // Hacemos el cast aquí
              evidencesRequiredAreLoad={evidencesRequiredAreLoad}
              showRequireds={false}
              setEvidencesDrawer={setEvidencesDrawer}
              setEvidencesRequiredAreLoad={setEvidencesRequiredAreLoad}
              close={handleCloseUpload}

            />
          )}
        </Box>
      </Drawer>

      <Box display="flex" justifyContent="space-between" width="100%" sx={{
        marginTop: {
          sm: 4,
          xl: 4
        }
      }}>
        <Button
          onClick={onBack}
          sx={{
            textTransform: "none",
            padding: 0,
            backgroundColor: "transparent",
            color: "primary.main",
            "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
          }}
        >
          Regresar
        </Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          disabled={!isFormValid}
          onClick={() => setConfirmModalOpen(true)}
          sx={{ borderRadius: '4px' }}
        >
          {!id ? 'Crear solicitud' : 'Editar solicitud'}
        </LoadingButton>
      </Box>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => !isSubmitting && setConfirmModalOpen(false)}
        onConfirm={handleSubmit}
        title={!id ? "Creación de folio" : "Edición de folio"}
        description={!id ? "¿Estás seguro que deseas crear este folio preventivo?" : "¿Estás seguro que deseas editar este folio preventivo?"}
        loading={isSubmitting}
      />
    </Box>

  );
};